module.exports = __webpack_public_path__ + "static/media/FreightWaves_Vaccaro Interview_Screenshot.fd37aef7.webp";